import axios from "axios";
import API from "../../common/API";
import { API_URL } from "../../config/config";

/*** 
@purpose : Get allocated sales office list
@Parameter : {}
**/
export const fetchAllocatedSalesOfficeList = async () => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(
      API_URL + API.GET_ALLOCATED_SALES_OFFICE_LIST + `?timestamp=${timestamp}`,
      {
        headers: {
          "x-api-key": token,
          "Access-Control-Allow-Origin": "*",
          timestamp: timestamp,
          mode: "no-cors",
        },
      }
    )
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get person classification list
@Parameter : {}
**/
export const fetchPersonClassificationsList = async () => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(
      API_URL + API.GET_PERSON_CLASSIFICATION_LIST + `&timestamp=${timestamp}`,
      {
        headers: {
          "x-api-key": token,
          "Access-Control-Allow-Origin": "*",
          timestamp: timestamp,
          mode: "no-cors",
        },
      }
    )
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get person medical speciality super type list
@Parameter : {}
**/
export const fetchPersonMedicalSpecialitySuperTypeList = async () => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(
      API_URL +
        API.GET_PERSON_MEDICAL_SPECIALITY_SUPER_TYPE_LIST +
        `&timestamp=${timestamp}`,
      {
        headers: {
          "x-api-key": token,
          "Access-Control-Allow-Origin": "*",
          timestamp: timestamp,
          mode: "no-cors",
        },
      }
    )
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get university list
@Parameter : {obj}
**/
export const fetchUniversityList = async () => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(API_URL + `/getuni?timestamp=${timestamp}`, {
      headers: {
        "x-api-key": token,
        "Access-Control-Allow-Origin": "*",
        timestamp: timestamp,
        mode: "no-cors",
      },
    })
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get medical speciality type list
@Parameter : {value}
**/
export const fetchMedicalSpecialityTypeList = async (value) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(
      API_URL +
        API.GET_PERSON_MEDICAL_SPECIALITY_TYPE_LIST +
        `?name="Person"&medicalSpecialityOneID=${value}&timestamp=${timestamp}`,
      {
        headers: {
          "x-api-key": token,
          "Access-Control-Allow-Origin": "*",
          timestamp: timestamp,
          mode: "no-cors",
        },
      }
    )
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get BU list
@Parameter : {}
**/
export const fetchBUList = async () => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(API_URL + API.GET_BU_LIST + `?timestamp=${timestamp}`, {
      headers: {
        "x-api-key": token,
        "Access-Control-Allow-Origin": "*",
        timestamp: timestamp,
        mode: "no-cors",
      },
    })
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get division list
@Parameter : {value}
**/
export const fetchDivisionList = async (value) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(
      API_URL + API.GET_DIVISION_LIST + `?buID=${value}&timestamp=${timestamp}`,
      {
        headers: {
          "x-api-key": token,
          "Access-Control-Allow-Origin": "*",
          timestamp: timestamp,
          mode: "no-cors",
        },
      }
    )
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Gte branch list
@Parameter : {value}
**/
export const fetchBranchList = async (value) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(
      API_URL +
        API.GET_BRANCH_LIST +
        `?buID=${value.buID}&divisionID=${value.divisionID}&timestamp=${timestamp}`,
      {
        headers: {
          "x-api-key": token,
          "Access-Control-Allow-Origin": "*",
          timestamp: timestamp,
          mode: "no-cors",
        },
      }
    )
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get sales office list
@Parameter : {value}
**/
export const fetchSalesOfficeList = async (value) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(
      API_URL +
        API.GET_SALES_OFFICE_LIST +
        `?buID=${value.buID}&divisionID=${value.divisionID}&branchID=${value.branchID}&timestamp=${timestamp}`,
      {
        headers: {
          "x-api-key": token,
          "Access-Control-Allow-Origin": "*",
          timestamp: timestamp,
          mode: "no-cors",
        },
      }
    )
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get allocated MR list
@Parameter : {body}
**/
export const getAllocatedMR = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return fetch(
    API_URL + API.GET_ALLOCATED_MR_LIST + `?timestamp=${timestamp}`,
    {
      method: "post",
      headers: {
        "x-api-key": token,
        "Access-Control-Allow-Origin": "*",
        timestamp: timestamp,
        mode: "no-cors",
      },
      body: JSON.stringify(body),
    }
  )
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Get person inquiry list
@Parameter : {body}
**/
export const getPersonInquiryList = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return fetch(
    API_URL + API.GET_PERSON_INQUIRY_LIST + `?timestamp=${timestamp}`,
    {
      method: "post",
      headers: {
        "x-api-key": token,
        "Access-Control-Allow-Origin": "*",
        timestamp: timestamp,
        mode: "no-cors",
      },
      body: JSON.stringify(body),
    }
  )
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Change language
@Parameter : {body}
**/
export const changeLanguage = (body) => async (dispatch) => {
  const payload = {
    data: body.language,
  };
  await dispatch({ type: "language", payload });
};

/*** 
@purpose : Get person details
@Parameter : {id}
**/
export const fetchPersonDetails = (id) => async (dispatch) => {
  const token = sessionStorage.getItem("token");
  const wwid = sessionStorage.getItem("WWID");
  let timestamp = new Date().getTime();
  return await axios
    .get(
      API_URL + API.GET_PERSON_INFO + `?perCustID=${id}&timestamp=${timestamp}`,
      {
        headers: {
          "x-api-key": token,
          wwid: wwid,
          "Access-Control-Allow-Origin": "*",
          timestamp: timestamp,
          mode: "no-cors",
        },
      }
    )
    .then((response) => {
      return response;
    });
};

/*** 
@purpose : Get person customer details
@Parameter : {id}
**/
export const getPersonCustomerDetails = (id) => async (dispatch) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(
      API_URL +
        API.GET_PERSON_CHANGE_REQUEST_DATA +
        `?perCustID=${id}&timestamp=${timestamp}`,
      {
        headers: {
          "x-api-key": token,
          "Access-Control-Allow-Origin": "*",
          timestamp: timestamp,
          mode: "no-cors",
        },
      }
    )
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        response.data.data.maintenanceWindowFlag = response.data.maintenanceWindowFlag
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get affiliation details
@Parameter : {body}
**/
export const getAffiliationDetails = (body) => async (dispatch) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(
      API_URL +
        API.GET_PERSON_CHANGE_REQUEST_DATA +
        `?perCustID=${body.personId}&affiliationID=${body.affiliationId}&timestamp=${timestamp}`,
      {
        headers: {
          "x-api-key": token,
          "Access-Control-Allow-Origin": "*",
          timestamp: timestamp,
          mode: "no-cors",
        },
      }
    )
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        response.data.data.maintenanceWindowFlag = response.data.maintenanceWindowFlag
        return response.data.data;
      }
    });
};

/*** 
@purpose : Person attribute change
@Parameter : {body}
**/
export const personAttributeChange = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  const wwid = sessionStorage.getItem("WWID");
  return fetch(API_URL + API.UPDATE_PERSON_CUSTOMER_DETAILS, {
    method: "post",
    headers: {
      "x-api-key": token,
      wwid: wwid,
      "Access-Control-Allow-Origin": "*",
      timestamp: timestamp,
      mode: "no-cors",
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Get gender list
@Parameter : {}
**/
export const fetchGenderList = async () => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(API_URL + API.GET_GENDER_LIST + `?timestamp=${timestamp}`, {
      headers: {
        "x-api-key": token,
        "Access-Control-Allow-Origin": "*",
        timestamp: timestamp,
        mode: "no-cors",
      },
    })
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Affiliation attribute change
@Parameter : {body}
**/
export const affiliationAttributeChange = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  const wwid = sessionStorage.getItem("WWID");
  return fetch(API_URL + API.UPDATE_AFFILIATION_DETAILS, {
    method: "post",
    headers: {
      "x-api-key": token,
      wwid: wwid,
      "Access-Control-Allow-Origin": "*",
      timestamp: timestamp,
      mode: "no-cors",
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Delete affiliation
@Parameter : {body}
**/
export const deleteAffiliation = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  const wwid = sessionStorage.getItem("WWID");
  return fetch(API_URL + API.DELETE_AFFILIATION, {
    method: "post",
    headers: {
      "x-api-key": token,
      wwid: wwid,
      "Access-Control-Allow-Origin": "*",
      timestamp: timestamp,
      mode: "no-cors",
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Add affiliation
@Parameter : {body}
**/
export const addAffiliation = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  const wwid = sessionStorage.getItem("WWID");
  return fetch(API_URL + API.ADD_AFFILIATION, {
    method: "post",
    headers: {
      "x-api-key": token,
      wwid: wwid,
      "Access-Control-Allow-Origin": "*",
      timestamp: timestamp,
      mode: "no-cors",
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};
